export default "__VITE_ASSET__Be8ED4ll__"